import { CuratedOrganization } from "models";
import React from "react";
import { FaEnvelope } from "react-icons/fa";
import { IoCalendarNumber } from "react-icons/io5";
import "./SecondaryInfo.scss";
import { GoOrganization } from "react-icons/go";

interface MayTermSecondaryInfoProps {
  /** The alum whose details should be displayed. */
  mayTerm: CuratedOrganization;
  /** Whether the details should be shown in a row or column. */
  direction?: "row" | "column";
}

/** Reusable component to display secondary information for an alum. */
export function MayTermSecondaryInfo({
  mayTerm,
  direction,
}: MayTermSecondaryInfoProps): JSX.Element {
  return (
    <div className={`secondary-info d-flex flex-${direction || "row"}`}>
      {mayTerm.date && (
        <span>
          <span className="margin-right">
            <IoCalendarNumber color="grey" size={23} />
          </span>
          {mayTerm.date}
        </span>
      )}

      {mayTerm.organization && (
        <span className="organization">
          <span className="margin-right">
            <GoOrganization color="grey" size={23} />
          </span>
          {mayTerm.organization?.charAt(0).toUpperCase()}
          {mayTerm.organization?.slice(1)}
        </span>
      )}

      {mayTerm.email && (
        <span>
          <FaEnvelope className="margin-right" color="grey" size={23} />
          {mayTerm.email}
        </span>
      )}
    </div>
  );
}
